<template>
  <div class="filter-form">
    <a-form
      :form="form"
      @submit="handleSubmit"
    >
      <div class="dev-form">
        <item-cascader
          v-for="(item, index) in selectDatas"
          :key="index"
          :item="item"
          :index="index"
          :type="type"
          :select-datas="selectDatas"
          @setShow="setShow"
        />
        <div
          v-if="isBtnShow"
          class="add-btn"
        >
          <i class="iconfont iconicon-test10" />
          <a
            href="javascript:;"
            @click="addItem"
          >{{ $t('message["1561"]') }}</a>
        </div>
      </div>
      <a-form-item class="pop-btn-box table-filter-th-box">
        <a-button @click="handlerReset">
          {{ $t('message["1625"]') }}
        </a-button>
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ItemCascader from './ItemCascader'

export default {
  components: {
    ItemCascader
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      selectDatas: [[]],
      newFromDatas: [],
      isBtnShow: false
    }
  },
  computed: {
    ...mapState('statistic', ['fromDatas', 'receptionType']),
    isDev () {
      return this.type && this.type === 'dev'
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetDetailTableDatas']),
    ...mapMutations('statistic', ['setIsTablePShow', 'setNewFromDatas']),
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // this.isBtnShow = false
          if (this.isDev) {
            document.querySelector('.dev-table-list th[key="fromtype"] .anticon-filter').click()
          } else {
            document.querySelector('.dev-table-list th[key="rectype"] .anticon-filter').click()
          }
          const selectDatasTemp = JSON.parse(JSON.stringify(this.selectDatas))
          let arrValues = []
          arrValues = selectDatasTemp.map(item => {
            let obj = {}
            item.forEach((val, key) => {
              obj[key + 1] = val
            })
            return obj
          })
          let objValues = {}
          if (this.isDev) {
            objValues = { 'fromtype': Object.keys(arrValues[0]).length === 3 ? arrValues : arrValues[0] }
          } else {
            objValues = { 'rectype': arrValues[0] }
          }
          this.$emit('filterFromHandler', objValues)

          // this.selectDatas = [[]]
          this.setIsTablePShow(false)
        }
      })
    },
    addItem () {
      this.selectDatas.push([])
    },
    setShow (b) {
      this.isBtnShow = b
    },
    handlerReset () {
      this.form.resetFields()
      this.selectDatas = [[]]
      this.isBtnShow = false
      if (this.isDev) {
        document.querySelector('.dev-table-list th[key="fromtype"] .anticon-filter').click()
      } else {
        document.querySelector('.dev-table-list th[key="rectype"] .anticon-filter').click()
      }

      this.$emit('filterFromHandler', { [this.isDev ? 'fromtype' : 'rectype']: {} })
      this.setIsTablePShow(false)
    }
  }
}
</script>
<style lang="scss" scoped>
  .filter-form::v-deep {
    position: relative;
    padding-bottom: 56px;
    .add-btn {
      margin-left: 30px;
    }
    .iconicon-test10 {
      color: #b3b3b3;
    }
    .iconicon-test8 {
      color: #b3b3b3;
      margin-left: 16px;
      cursor: pointer;
    }
    .label-title {
      width: 30px;
      display: inline-block;

    }
    .pop-btn-box {
      position: fixed;
      bottom: 0;
    }
    .dev-form {
      padding:0 40px 20px;
      min-height: 120px;
      max-height:280px;
      overflow-y: auto;
    }
    .pop-btn-box {
      position: absolute;
      border-top: 1px solid #ebebeb;
      height: 36px;
      // padding-top: 12px;
      text-align: right;
      bottom: 0;
      right: 0;
      width: 100%;
      &.ant-form-item {
        margin-bottom: 0;
      }
      .ant-btn {
        background: none !important;
        border:none;
        color: #5077AA;
        box-shadow: none;
        text-shadow: none;
        line-height: 36px;
        height: 36px;
        border-radius: 0;
        padding: 0 26px;
        margin-right: 0;
      }
       .ant-btn-primary {
        border-left: 1px solid #ebebeb;

      }
    }
  }
</style>
